import BSCornmealProduct from 'models/BSCornmealProduct'

export const packagingInitialState = {
  category: BSCornmealProduct.category,
  subCategory: BSCornmealProduct.subCategory,
  Size: BSCornmealProduct.Size,
  FDACert: BSCornmealProduct.FDACert,
  Organic: BSCornmealProduct.Organic,
}
